<template>
  <!-- Content -->
  <div class="card1 mb-3">
    <div class="card-body">
      <div class="row p-sm-3 p-0">
        <div class="col-md-6 mb-md-0 mb-4">
          <div class="d-flex svg-illustration mb-4 gap-2">
          </div>
          <p class="mb-1 fw-bold">LAMODA VIETNAM COMPANY LIMITED</p>
          <p class="mb-1">Ho Chi Minh City, Vietnam</p>
          <p class="mb-0">+84 (0) 394 577 366</p>
        </div>
        <div class="col-md-6">
          <dl class="row mb-2">
            <dt class="col-sm-6 mb-2 mb-sm-0 text-md-end mt-2">
              <span class="h5 text-capitalize mb-0 text-nowrap">Receiving Voucher No</span>
            </dt>
            <dd class="col-sm-6 d-flex justify-content-md-end">
              <div class="w-px-200">
                <input type="text" 
                  class="form-control" 
                  v-model="stateData.receiving_voucher_no"
                  disabled
                >
              </div>
            </dd>
            <dt class="col-sm-6 mb-2 mb-sm-0 text-md-end mt-2">
              <span class="h5 text-capitalize mb-0 text-nowrap">Invoice No</span>
            </dt>
            <dd class="col-sm-6 d-flex justify-content-md-end">
              <div class="w-px-200">
                <input type="text" 
                  class="form-control" 
                  v-model="stateData.invoice_code"
                  disabled
                >
              </div>
            </dd>
            <dt class="col-sm-6 mb-2 mb-sm-0 text-md-end mt-2">
              <span class="fw-normal">Contract No</span>
            </dt>
            <dd class="col-sm-6 d-flex justify-content-md-end">
              <div class="w-px-200">
                <input type="text" 
                  class="form-control"
                  v-model="this.stateData.contract_code"
                  disabled
                >
              </div>
            </dd>
            <dt class="col-sm-6 mb-2 mb-sm-0 text-md-end mt-2">
                <span class="fw-normal">Issued Date</span>
            </dt>
            <dd class="col-sm-6 d-flex justify-content-md-end">
              <div class="w-px-200">
                <flat-pickr 
                  v-model="stateData.receiving_voucher_date" 
                  :config="calendarConfig" 
                  placeholder="Select a date" 
                  name="contract-date" 
                  class="form-control"
                >
                </flat-pickr>
              </div>
            </dd>
          </dl>
        </div>
      </div>
      <hr class="my-4 mx-n4">
      <div class="row p-sm-0 p-0">
        <div class="col-md-6 col-sm-6 col-12 mb-sm-0 mb-4" v-if="stateData.supplierInfo.id">
          <h6 class="pb-2 fw-bold">Supplier Information</h6>
          <div class="alert alert-primary mt-1" role="alert">
            <div class="row">
              <div class="mb-2">
                <span class="fw-bold me-3">{{ stateData.supplierInfo.partner_name }}</span>
                <div class="mt-2">
                  <span class="fw-bold me-3">Address:</span>
                  {{ stateData.supplierInfo.address +" "+ stateData.supplierInfo.ward_name +" "+ 
                    stateData.supplierInfo.district_name +" "+ stateData.supplierInfo.city_name +" "+ stateData.supplierInfo.country}}
                  {{ stateData.supplierInfo.zipcode ? ", zipcode: " + stateData.supplierInfo.zipcode : "" }}
                </div>
                <div class="mt-3">
                  <span class="fw-bold me-3">Payment method:</span>
                  {{ getPaymentName(stateData.supplierInfo.payment_method) +" "+ stateData.supplierInfo.term +" days "+ getClosingTime(stateData.supplierInfo.closing_time) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6" v-if="stateData.supplierInfo.id">
          <h6 class="pb-2 fw-bold">Supplier Bank Information</h6>
          <div class="alert alert-primary mt-1" role="alert">
            <div class="row">
              <div class="mb-2">
                <span class="alert-heading fw-bold mt-2">BANK INFORMATION</span><br/>
                <span class="fw-bold me-1">
                  {{ showBankName(stateData.supplierInfo.bank_name) }}
                  {{ " (" + stateData.supplierInfo.bank_name + ")" }}
                </span><br/>
                <span class="fw-bold me-3">Account Name:</span>{{ stateData.supplierInfo.bank_account_name }}<br/>
                <span class="fw-bold me-3">Account No:</span>{{ stateData.supplierInfo.bank_account_number }}<br/>
                <span class="fw-bold me-3">SWIFT code:</span>{{ stateData.supplierInfo.swift_code }} <br/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mx-n4">
      <div class="card-body">
        <div class="d-flex border rounded position-relative mb-3" v-for="(product, key) in stateData.list_products" :key="key">
          <receiving-product-detail
            :product="product"
            :index="key"
          >
          </receiving-product-detail>
        </div>
        <!-- Grand Total Amount -->
        <div class="row col-md-12 mt-5">
          <div class="col-md-5 d-flex justify-content-end" style="margin-left:5rem">
            <div class="invoice-calculations">
              <div class="d-flex justify-content-between mb-4">
                <span class="fw-bold w-px-200"></span>
                <span class="fw-bold">PURCHASE</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="fw-bold w-px-200">Subtotal:</span>
                <span class="fw-semibold">{{ stateData.buy_currency }}&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.sub_total_buy) }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="fw-bold w-px-200">Tax:</span>
                <span class="fw-semibold">{{ stateData.buy_currency }}&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.tax_total_buy) }}</span>
              </div>
              <hr>
              <div class="d-flex justify-content-between mb-2">
                <span class="fw-bold w-px-200">Grand Total:</span>
                <span class="fw-semibold">{{ stateData.buy_currency }}&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.grand_total_buy_price) }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="fw-bold w-px-200">Grand Total in VND</span>
                <span class="fw-semibold">VND&nbsp;&nbsp;&nbsp;{{ getFormatCurrency(stateData.grand_total_buy_vnd) }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-5">
            <span class="fw-bold me-2">GRAND PURCHASE AMOUNT: </span> 
            <span class="fw-bold text-primary">{{ getFormatCurrencyText(stateData.grand_total_buy_text) }}&nbsp;{{ stateData.buy_currency }}</span>
          </div>
        </div>
        <!-- / Grand Total Amount -->
      </div>
    </div>
    <!-- Modal -->
    <div class="modal modal-transparent show fade" v-if="isLoading" id="basicModal" style="display: block;">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <rise-loader :color="color" :size="size" style="text-align:center;"></rise-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- / Content -->
</template>

<script>
import { mapState } from "vuex";
import flatPickr from 'vue-flatpickr-component';
import { configs } from '@/config/calendar.js';
import useValidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { CLOSING_TIME, PAYMENT_METHOD } from "../../config/common.js"
import banks from "../../../public/assets/vendor/js/bank.js"
import ReceivingProductDetail from "../receiving/ReceivingProductDetail.vue";
// import {Converter} from "any-number-to-words";
import RiseLoader from 'vue-spinner/src/RiseLoader.vue'


export default {
  name: 'ReceivingVoucherAdd',
  components: {
    flatPickr,
    ReceivingProductDetail,
    RiseLoader
  },
  data() {
    return {
      v$: useValidate(),
      calendarConfig: configs,
      color: '#696cff',
      size: '20px',
      isLoading: false,
      subTotalBuyPrice: null,
      subTotalSellPrice: null,
      grandTotalBuyTax: null,
      grandTotalSellTax: null,
      grandTotalBuyPriceVND: null,
      grandTotalSellPriceVND: null,
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.shipmentAdd.stateData
    }),
    bankOptions() {
      return banks;
    },
    paymentMethodOptions() {
      return PAYMENT_METHOD;
    }
  },
  watch: {
  },
  created() {
    this.isLoading = true;
  },
  mounted(){
    this.isLoading = false;
  },
  methods: {
    getFormatCurrency(value) {
      return Intl.NumberFormat().format(value);
    },
    getFormatCurrencyText(value) {
      return value.toUpperCase();
    },
    getClosingTime(close_time_id) {
      let query = CLOSING_TIME.filter(item => item.id == close_time_id);
      return query[0].name
    },
    getPaymentName(val) {
      let query = this.paymentMethodOptions.filter((item) => {
        return item.value == val;
      });
      return query.length > 0 ? query[0].name_en : ""
    },
    showBankName(bank_code) {
      if (!bank_code) return "";
      let bank_name = this.bankOptions.filter(item => {
        return item.code == bank_code
      });
      return bank_name.length > 0 ? bank_name[0].name : "";
    }
  },
  validations() {
    return {
      stateData: {
        invoice_date: {
          required: helpers.withMessage('Issued Date can not be empty', required)
        }
      }
    }
  }
}
</script>